import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { ReportsService } from "src/app/features/reports/reports.service";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { FormControl } from "@angular/forms";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";
const helper = new JwtHelperService();
@Component({
  selector: 'app-transaction-summary',
  templateUrl: './transaction-summary.component.html',
  styleUrls: ['./transaction-summary.component.scss'],
  providers: [CurrencyPipe]
})
export class TransactionSummaryComponent extends FeaturesBaseComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input() realtime;
  @Input() summary;
  @Input() startDate;
  @Input() endDate;
  toCtrl = new FormControl("");
  fromCtrl = new FormControl("");
  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  //summary:  Array<any>;
  minFromDate;
  maxDate;
  minToDate;
  dateSelected: any;
  historyDays = [{ days: 1, value: 'Today' },
  { days: 2, value: 'Yesterday' },
  { days: 3, value: 'This Week' },
  { days: 4, value: 'Last Week' },
  { days: 5, value: 'This Month' },
  { days: 6, value: 'Last Month' },
  { days: 7, value: 'This Year' }];
  selectedDays = this.historyDays[0].days;

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe
  ) {
    super();
    this.setGrid();
    this.showTodayDate()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["realtime"]) {
      this.realtime = changes["realtime"].currentValue;
      this.rowData = this.realtime;
    }
    if (changes["summary"]) {


      this.summary = changes["summary"].currentValue;
    }
    changes["startDate"]
      ? (e) => {
        this.startDate = changes["startDate"].currentValue;
        this.minFromDate = this.startDate;

        this.fromCtrl.setValue(this.minFromDate);
      }
      : this.startDate;
    changes["endDate"]
      ? (e) => {
        this.endDate = changes["endDate"].currentValue;
        this.minToDate = this.endDate;
        this.toCtrl.setValue(this.minToDate);
      }
      : this.endDate;
  }

  setGrid() {
    const self = this;
    this.columnDefs = [
      {
        field: "transactionDate",
        headerName: "Date",
        width: 180,
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "transactionTime",
        headerName: "Transaction Time",
        width: 210,
        cellRenderer: (data) => {
          return moment(data.value).format("hh:mm:ss:a");
        },
      },
      //
      {
        field: "responseTime",
        headerName: "Response Time",
        width: 200,
        cellRenderer: (data) => {
          return this.millisToMinutesAndSeconds(data.value);
        },
      },
      //
      { field: "sku", headerName: "SKU", width: 130 },
      { field: "productName", headerName: "Product", width: 350 },
      { field: "retailerName", headerName: "Retailer Name", width: 450 },
      {
        field: "faceValue",
        headerName: "Face Value",
        width: 180,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "fee",
        headerName: "Fee",
        width: 180,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "retailerAccount",
        headerName: "Retailer Account Number",
        width: 290,
      },
      { field: "beneficiaryNumber", headerName: "Beneficiary", width: 200 },
      { field: "customerNumber", headerName: "Sender Number", width: 240 },
      { field: "loyaltyPointsEarned", headerName: "Points Earned ", width: 240 },
      { field: "confirmationNumber", headerName: "Confirmation", width: 210 },
      { field: "salesRep", headerName: "Sales Dist./Rep", width: 250 },
      {
        field: "codeGroup",
        headerName: "Code Group",
        width: 240,
        cellRenderer: (params) => {
          if (params.value.toLowerCase() === "pinless" && params.data.faceValue > 0) {
            if (params.data.refundStatus == null || params.data.refundStatus?.toLowerCase() != "yes") {
              return `${params.value}  &nbsp;<span class="rounded-pill bg-main text-white px-2 py-1 cur-point">Refund</span>`
            }

            if (params.data.refundStatus != null && params.data.refundStatus?.toLowerCase() == "yes") {
              return `${params.value}  &nbsp;<span class="rounded-pill bg-light text-main px-2 py-1">Refunded</span>`
            }
          }
          return params.value;
        },
        onCellClicked: function (params) {
          if (params.value == "PINLESS") {
            self.handleApprove(params.data);
          }
        },
      },
      { field: "promoCode", headerName: "Promo Code", width: 200 },
      {
        field: "ammountAppliedForPromo",
        headerName: "Promo Code Value",
        width: 250,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value, "USD");
        },
      }
    ];
    //this.rowData = []
  }

  handleApprove(rowData) {
    if (rowData.faceValue < 0 || (rowData.refundStatus?.toLowerCase() == "yes")) {
      return

    }
    //alert
    //;
    if (rowData.beneficiaryNumber && rowData.beneficiaryNumber) {
      let formData: any = {
        beneficiaryNumber: rowData.beneficiaryNumber,
        productType: rowData.productType,
        rechargeAmount: rowData.faceValue,
        requestId: rowData.requestId,
      };

      this.reportsService.approvePinlessrefund(formData).subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.toastrService.success(`Refund Successful!`, `Success`);
          let params: any = new HttpParams()
            .set("startDate", this.startDate)
            .set("endDate", this.endDate);
          this.reportsService.getrealtime(params).subscribe((res) => {
            let resData: any = res;
            if (resData.httpcode == 200) {
              resData = resData.data;
              this.setRowData(res["data"]);
              this.realtime = resData;
            }
          });
        }

      });
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  millisToMinutesAndSeconds(millis) {
    let minutes: number = Math.floor(millis / 60000);
    let sec: number = (millis % 60000) / 1000;
    return minutes + ":" + (sec < 10 ? "0" : "") + sec;
  }
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Real-Time-Transactions.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === "") {
        return ""; //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "responseTime") {
        return this.millisToMinutesAndSeconds(cellParams.value); //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "requestId") {
        return parseInt(cellParams.value); //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "transactionDate") {
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else if (
        (cellParams && cellParams.column.colId === "transactionTime") ||
        cellParams.column.colId === "requestTime" ||
        cellParams.column.colId === "requestRecivedTime" ||
        cellParams.column.colId === "responseRecivedTime" ||
        cellParams.column.colId === "responseTime"
      ) {
        return moment(cellParams.value).format("hh:mm:ss:a");
      } else if (
        (cellParams && cellParams.column.colId === "faceValue") ||
        cellParams.column.colId === "fee" ||
        cellParams.column.colId === "purchasePrice" ||
        cellParams.column.colId === "grossProfit" ||
        cellParams.column.colId === "ammountAppliedForPromo" ||
        cellParams.column.colId === "netProfit"
      ) {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }
  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService.getrealtimeSummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
        this.reportsService.getrealtime(params).subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.setRowData(res["data"]);
            this.realtime = resData;
          }
        });
      }
    });
  }
  setRowData(rowData: any) {
    this.rowData = rowData;
  }
  changehistory(e) {
    this.dateSelected = e.value;
    var dt = new Date();

    var dt = new Date();
    dt.setDate(dt.getDate() - this.dateSelected);

    switch (this.dateSelected) {
      case 1: { //Today
        this.endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.startDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.showTodayDate()
        break;
      }
      case 2: { //Yesterday
        var dt = new Date();
        dt.setDate(dt.getDate() - 1)
        this.endDate = formatDate(dt, 'yyyy-MM-dd', 'en');
        this.startDate = formatDate(dt, 'yyyy-MM-dd', 'en');
        this.showYesterday()
        break;
      }
      case 3: { //This Week
        var curr = new Date; // get current date
        var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
        var last = first + 6; // last day is the first day + 6
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();

        this.endDate = formatDate(lastday, 'yyyy-MM-dd', 'en');
        this.startDate = formatDate(firstday, 'yyyy-MM-dd', 'en');
        this.thisWeek()
        break;
      }
      case 4: { //Last Week
        const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");

            let startOfLastWeek = moment().subtract(1, 'week').startOf('week');
            let startDate = startOfLastWeek.toDate();
            
            let endOfLastWeek = moment().subtract(1, 'week').endOf('week').subtract(0, 'day');
            let endDates = endOfLastWeek.toDate();
              
                this.endDate = formatDate(endDates, 'yyyy-MM-dd', 'en');
                this.startDate = formatDate(startDate, 'yyyy-MM-dd', 'en');
                this.lastWeek()
        break;
      }
      case 5: { //This Month
        let date = new Date();
        this.startDate = formatDate(
          new Date(date.getFullYear(), date.getMonth(), 1),
          "yyyy-MM-dd",
          "en"
        );
        this.endDate = formatDate(
          new Date(date.getFullYear(), date.getMonth() + 1, 0),
          "yyyy-MM-dd",
          "en"
        );
    
        this.thisMonth()
        break;
      }
      case 6: { //Last Month
        let date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.startDate = formatDate(firstDay, 'yyyy-MM-dd', 'en');
        this.endDate = formatDate(lastDay, 'yyyy-MM-dd', 'en');
        this.lastMonth();

        break;
      }
      case 7: { //This Year
        let date = new Date();
        this.startDate = formatDate(
          new Date(date.getFullYear(), 0, 1),
          "yyyy-MM-dd",
          "en"
        );
        this.endDate = formatDate(
          new Date(date.getFullYear(), 11, 31),
          "yyyy-MM-dd",
          "en"
        );
              
        
        this.thisYear();
        break;
      }
      default: { //This Year
        let date = new Date();
        this.startDate = formatDate(
          new Date(date.getFullYear(), 0, 1),
          "yyyy-MM-dd",
          "en"
        );
        this.endDate = formatDate(
          new Date(date.getFullYear(), 11, 31),
          "yyyy-MM-dd",
          "en"
        );
                this.thisYear()
        break;
      }
    }
    this.getDateChangeResult(this.startDate, this.endDate);

  }

  showTodayDate() {
    this.endDate = formatDate(new Date(), "yyyy-MM-dd", "en");
       this.startDate = formatDate(new Date(), "yyyy-MM-dd", "en");
       let today = moment().startOf('day').toDate();
       let date = new Date();
       let startOfMonth = moment.utc().startOf("month").toDate();
       this.fromCtrl.setValue(startOfMonth);
       this.toCtrl.setValue(date);
       console.log('today date',today);
     this.fromCtrl.setValue(today);
 }

 showYesterday() {
   const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");
   const startDate = formatDate(new Date(), "yyyy-MM-dd", "en");
   // Get today's date at the start of the day
   let today = moment().startOf('day').toDate(); 
   // Get yesterday's date at the start of the day
   let yesterday = moment().subtract(1, 'days').startOf('day').toDate(); 
   // Set the 'from' control to yesterday's date and the 'to' control to today's date
   this.fromCtrl.setValue(yesterday);  // Set the 'from' date to yesterday
   this.toCtrl.setValue(yesterday);  // Set the 'to' date to today
 }

 thisWeek() {
   const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");

   let startOfWeek = moment().startOf('week');
   let startDate = startOfWeek.toDate();
   
   let endOfWeek = moment().endOf('week').subtract(0, 'day');
   let endDates = endOfWeek.toDate();
   
   this.fromCtrl.setValue(startDate);
   this.toCtrl.setValue(endDates);

 }

 lastWeek() {
   const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");

   let startOfLastWeek = moment().subtract(1, 'week').startOf('week');
   let startDate = startOfLastWeek.toDate();
   
   let endOfLastWeek = moment().subtract(1, 'week').endOf('week').subtract(0, 'day');
   let endDates = endOfLastWeek.toDate();
   
   this.fromCtrl.setValue(startDate);
   this.toCtrl.setValue(endDates);
   

 }

 thisMonth() {
   const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");
   let startOfMonth = moment().startOf('month');
   let startDate = startOfMonth.toDate();
   let endOfMonth = moment().endOf('month');
   let endDates = endOfMonth.toDate();

this.fromCtrl.setValue(startDate);
this.toCtrl.setValue(endDates);


 }

 lastMonth() {
   const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");

let startOfLastMonth = moment().subtract(1, 'month').startOf('month');
let startDate = startOfLastMonth.toDate();

let endOfLastMonth = moment().subtract(1, 'month').endOf('month');
let endDates = endOfLastMonth.toDate();

this.fromCtrl.setValue(startDate);
this.toCtrl.setValue(endDates);

 }


 thisYear() {
   const endDate = formatDate(new Date(), "yyyy-MM-dd", "en");

let startOfYear = moment().startOf('year');
let startDate = startOfYear.toDate();

let endOfYear = moment().endOf('year');
let endDates = endOfYear.toDate();

this.fromCtrl.setValue(startDate);
this.toCtrl.setValue(endDates);

 }
}
